import { button } from './jp/button';
import { message } from './jp/message';
import { shared } from './jp/shared';
import { login } from './jp/login';
import { menu } from './jp/menu';
import { header } from './jp/header';
import { user } from './jp/user';
import { reveneu } from './jp/reveneu';

export const locale = {
  lang: 'jp',
  data: {
    menu,
    button,
    message,
    shared,
    login,
    header,
    user,
    reveneu,
  },
};
